import "./modal.scss";
import ReactDOM from "react-dom";
import { motion } from "framer-motion";
import { useEffect } from "react";
import { cleanObject } from "../../../helpers";

const Modal = ({
  children,
  width,
  isActive = false,
  closeModal = () => {},
  closeViaOverlay = true,
  top,
  left,
  position = "center",
  returnAsSent = false,
  padding,
  style = {},
  backDropStyle = {},
}) => {
  // Lock background scroll when modal is active
  useEffect(() => {
    if (isActive) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    // Cleanup function to re-enable scroll on modal close
    return () => {
      document.body.style.overflow = "";
    };
  }, [isActive]);

  // Render modal only if it's active
  if (!isActive) return null;

  if (returnAsSent) return children;

  return ReactDOM.createPortal(
    <div className="modal" style={{ ...backDropStyle }}>
      {/* back layer */}
      <div
        onClick={() => {
          if (closeViaOverlay) closeModal();
        }}
        className="modal__backdrop"
      ></div>
      {/* modal section */}
      <motion.div
        initial={{
          y: position === "center" ? -50 : 0,
          x: position === "left" || position === "right" ? `${width}` : 0,
        }}
        animate={{
          y: 0,
          x: 0,
          transition: { duration: 0.3 },
        }}
        className={`${
          position === "center" || position === "left" || position === "right"
            ? "modal__container"
            : "modal__more"
        }`}
        style={cleanObject({
          width: width,
          top: top,
          left: left,
          padding: padding,
          ...style,
        })}
      >
        {children}
      </motion.div>
    </div>,
    document.getElementById("modal-root"),
  );
};

export default Modal;
